"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowTextEditor_1 = require("../../../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowButtonSet_1 = require("../../../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../../../shared/components/editors/CardRowSelectEditor");
var TabEditorContainer_1 = require("../../../../../../../../shared/components/containers/TabEditorContainer");
var BrandMessageTemplateEditor = /** @class */ (function (_super) {
    __extends(BrandMessageTemplateEditor, _super);
    function BrandMessageTemplateEditor(props) {
        var _this = _super.call(this, props) || this;
        _this.key_main = "main";
        return _this;
    }
    BrandMessageTemplateEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record != null) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    title: _item.title,
                    message_action_code: _item.message_action_code,
                    message_action_title: _item.message_action_title,
                    description: _item.description,
                    tabKey: this.key_main,
                    app_language_id: _item.app_language_id,
                    app_language_title: _item.app_language_title,
                    _actions: [],
                    _langs: [],
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Шаблоны бренда", "Редактирование шаблона бренда"]);
                });
            }
        }
        else {
            this.setState({
                title: "",
                description: "",
                message_action_title: "",
                message_action_code: 0,
                tabKey: this.key_main,
                app_language_id: 0,
                app_language_title: "",
                _actions: [],
                _langs: [],
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Шаблоны бренда", "Создание шаблона бренда"]);
            });
        }
        this.SID_TACT = this.props.listMessageTemplateActions.Subscribe("*", function (id, data) {
            _this.setState({
                _actions: data.data
            });
        });
        this.SID_LANG = this.props.langsAvail.Subscribe("*", function (id, data) {
            _this.setState({
                _langs: data.data
            });
        });
        this.props.listMessageTemplateActions.LoadData();
        this.props.langsAvail.LoadData();
        this.doReSetRules();
    };
    BrandMessageTemplateEditor.prototype.componentWillUnmount = function () {
        this.props.listMessageTemplateActions.UnSubscribe(this.SID_TACT);
        this.props.langsAvail.UnSubscribe(this.SID_LANG);
    };
    BrandMessageTemplateEditor.prototype.doReSetRules = function () {
        this.setState({
            title_rules: { isError: false },
            message_action_rules: { isError: false },
            app_language_rules: { isError: false },
        });
    };
    BrandMessageTemplateEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((!this.state.title) || (this.state.title.length === 0)) {
            this.setState({ title_rules: { isError: true, errorMessage: "Поле [название] не заполнено!" } });
            return false;
        }
        if ((this.state.message_action_code <= 0) || (this.state.message_action_title.length === 0)) {
            this.setState({ message_action_rules: { isError: true, errorMessage: "Тип действия шаблона не выбран!" } });
            return false;
        }
        if ((this.state.app_language_id <= 0) || (this.state.app_language_title.length === 0)) {
            this.setState({ app_language_rules: { isError: true, errorMessage: "Язык шаблона не выбран!" } });
            return false;
        }
        return true;
    };
    BrandMessageTemplateEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditGwsMessageTemplate({
                key: this.props.record.key,
                description: this.state.description,
                title: this.state.title,
                message_action_code: this.state.message_action_code,
                app_language_id: this.state.app_language_id,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Шаблон емэйл сообщения изменен!");
            });
        }
    };
    BrandMessageTemplateEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddGwsMessageTemplate({
                brand_id: this.props.rootRecord.key,
                title: this.state.title,
                description: this.state.description,
                message_action_code: this.state.message_action_code,
                app_language_id: this.state.app_language_id,
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Шаблон емэйл сообщения создан!");
            });
        }
    };
    BrandMessageTemplateEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    BrandMessageTemplateEditor.prototype.getFormTitle = function () {
        if (this.props.record == null) {
            return "Новый шаблон сообщения";
        }
        else {
            return "Изменить шаблон сообщения";
        }
    };
    BrandMessageTemplateEditor.prototype.getMainEditContent = function () {
        var _this = this;
        return (React.createElement("div", { style: {
                minHeight: "500px",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "flex-start"
            } },
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Название:", placeholder: "Введите название" }, value: this.state.title, onValueChanged: function (newVal) {
                    _this.setState({
                        title: newVal,
                        title_rules: { isError: false }
                    });
                }, required: true, rules: this.state.title_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal
                    });
                } }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип действия:", placeholder: "Выберите тип действия" }, value: { key: this.state.message_action_code, value: this.state.message_action_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        message_action_code: newVal.key,
                        message_action_title: newVal.value,
                        message_action_rules: { isError: false }
                    });
                }, items: this.state._actions, required: true, rules: this.state.message_action_rules }),
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Язык шаблона:", placeholder: "Выберите язык шаблона" }, value: { key: this.state.app_language_id, value: this.state.app_language_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        app_language_id: newVal.key,
                        app_language_title: newVal.value,
                        app_language_rules: { isError: false }
                    });
                }, items: this.state._langs, required: true, rules: this.state.app_language_rules }),
            React.createElement("div", { style: { minHeight: "43px" } }),
            this.getDownButtons()));
    };
    BrandMessageTemplateEditor.prototype.getDownButtons = function () {
        return (React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) }));
    };
    BrandMessageTemplateEditor.prototype.onTabChange = function (key) {
        this.setState({ tabKey: key });
    };
    BrandMessageTemplateEditor.prototype.getContent = function () {
        if (this.state.tabKey === this.key_main) {
            return this.getMainEditContent();
        }
        return null;
    };
    BrandMessageTemplateEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(TabEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 580, activeTabKey: this.state.tabKey, tabs: [
                { key: this.key_main, tab: "Основные" },
            ], onTabChange: function (key) { _this.onTabChange(key); } }, this.getContent()));
    };
    return BrandMessageTemplateEditor;
}(React.Component));
exports.default = BrandMessageTemplateEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/main_brands_list/ui/component/options/message/BrandMessageTemplateEditor.tsx
// module id = 1805
// module chunks = 0